import React, {useEffect, useState} from 'react';
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { Document } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { DocumentItem } from "../DocumentItem";

const documentController = new Document();

export function ListDocument(props) {

  const { reload, onReload } = props;
  const [documents, setDocuments] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setDocuments(null);
        const response = await documentController.getDocuments(accessToken);
        setDocuments(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload, accessToken]);

  if (!documents) return <Loader active inline="centered" />;
  if (size(documents) === 0) return "No existen documentos registrados";

  return map(documents, (document) => (
    <DocumentItem key={document.id} document={document} onReload={onReload} />
  ));
}
